export default [
  {
    title: '策略ID',
    key: 'id',
    width: 72,
    fixed: true
  },
  {
    title: '策略名称',
    key: 'strategyName',
    width: 150,
    fixed: true
  },
  {
    title: '平台',
    key: 'platform',
    width: 72
  },
  {
    title: '游戏',
    key: 'gameNames',
    width: 120,
    overflow: true
  },
  {
    title: '投放速度类型',
    key: 'flow_control_mode',
    width: 98
  },
  {
    title: '投放位',
    key: 'inventory_type',
    width: 102,
    overflow: true
  },
  {
    title: '计划预算',
    key: 'budget',
    width: 72
  },
  {
    title: '出价类型',
    key: 'smart_bid_type',
    width: 72
  },
  {
    title: '出价',
    key: 'cpa_bid',
    width: 72
  },
  {
    title: '深度转化出价',
    key: 'deep_cpabid',
    width: 102
  },
  {
    title: '转化追踪类型',
    key: 'convertIndex',
    width: 102,
    overflow: true
  },
  {
    title: '投放时间',
    key: 'schedule_type',
    width: 170
  },
  {
    title: '投放时段',
    key: 'schedule_time',
    width: 88
  },
  {
    title: '应用名',
    key: 'app_name',
    width: 72
  },
  {
    title: '副标题',
    key: 'sub_title',
    width: 102
  },
  {
    title: '创意分类',
    key: 'mult_categroy',
    width: 102,
    overflow: true
  },
  {
    title: '创意标签',
    key: 'ad_keywords',
    width: 102,
    overflow: true
  },
  {
    title: '应用下载详情页',
    key: 'web_url',
    width: 240,
    overflow: true
  },
  {
    title: '新建时间',
    key: 'createTime',
    width: 140
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 140
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 72
  },
  {
    title: '操作',
    key: 'control',
    width: 140,
    fixed: true
  }
]
